import { parseApiError, parseNetworkOrUnknownError, type ParsedApiError } from '@loctopus/shared';
import { LoctopusApiError, LoctopusNetworkError } from '@loctopus/ticketing-sdk';
import { getLastKnownBaseUrl } from './config';

/**
 * The one-line adapter apps/checkout needs between `@loctopus/ticketing-sdk`'s own error classes
 * (`LoctopusApiError`/`LoctopusNetworkError`, packages/sdk/src/errors.ts) and
 * `@loctopus/shared`'s app-agnostic `parseApiError` - same pattern as apps/dashboard's and
 * apps/admin's `lib/errorDisplay.ts`. Previously every page here caught the SDK's error directly
 * and rendered a bare `err.message` string (no request ID, no field-level detail, no reauth/
 * permission/conflict distinction) - this is what every page now goes through instead.
 */
export function toParsedError(err: unknown): ParsedApiError {
  if (err instanceof LoctopusApiError) {
    return parseApiError({
      code: err.code,
      message: err.message,
      details: err.details,
      requestId: err.requestId,
      httpStatus: err.httpStatus,
    });
  }
  if (err instanceof LoctopusNetworkError) {
    return parseNetworkOrUnknownError(err, getLastKnownBaseUrl());
  }
  return parseNetworkOrUnknownError(err, getLastKnownBaseUrl());
}
